module.exports = __webpack_public_path__ + "img/phone.cc8640c6.png";